export default __webpack_public_path__ + "static/media/planet-mercury.1fce205c.svg";